import { QueryObserverOptions } from "@tanstack/react-query"

import { Duration } from "@shared/types/duration"
import {
  PrescribedMedicationRequestRequest,
  SelfDefinedMedicationRequestRequest,
} from "@shared/zod/schemas/requests/medicationRequest"
import {
  MedicationPrescribedResponse,
  PatientPreviousMedicationRequestsResponse,
} from "@shared/zod/schemas/responses/medicationRequest"

import { axiosPatient } from "./generic/AxiosInterceptor/AxiosInterceptor"

// Sets defaults used in `buildApiFromServices`.
// Avoid refetching too often. The medical files do not change that often
export const queryOptions: Partial<QueryObserverOptions> = {
  staleTime: Duration.from("30 minutes").milliseconds,
  refetchOnMount: false,
  refetchOnWindowFocus: false,
  refetchInterval: false,
}

export const prescribed = (): Promise<MedicationPrescribedResponse> => {
  return axiosPatient({
    url: "/patient/medicationrequests/prescribed",
    method: "get",
  }).then((resp) => resp.data)
}

/** The patient's own latest requests, newest first, to refill the form from. */
export const previous = (): Promise<PatientPreviousMedicationRequestsResponse> => {
  return axiosPatient({
    url: "/patient/medicationrequests/previous",
    method: "get",
  }).then((resp) => resp.data)
}

export const selfDefinedCreate = (medication: SelfDefinedMedicationRequestRequest): Promise<void> => {
  return axiosPatient({
    url: "/patient/medicationrequests/selfdefined",
    method: "post",
    data: medication,
  }).then(() => undefined)
}

export const prescribedCreate = (medication: PrescribedMedicationRequestRequest): Promise<void> => {
  return axiosPatient({
    url: "/patient/medicationrequests/prescribed",
    method: "post",
    data: medication,
  }).then(() => undefined)
}
